module.exports = __webpack_public_path__ + "static/media/img4.c2d1663d.jpg";